import { render, staticRenderFns } from "./FloatAssignForm.vue?vue&type=template&id=2c227680&scoped=true"
import script from "./FloatAssignForm.vue?vue&type=script&lang=js"
export * from "./FloatAssignForm.vue?vue&type=script&lang=js"
import style0 from "./FloatAssignForm.vue?vue&type=style&index=0&id=2c227680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c227680",
  null
  
)

export default component.exports